// extracted by mini-css-extract-plugin
export default {"wrapperAbout":"About_wrapperAbout__i1328","wrapper":"About_wrapper__iLEms","roles":"About_roles__G14jJ","avatar":"About_avatar__CuL3I","float":"About_float__HXP7v"};